import React from 'react';

import { Form, Modal, Rate } from 'antd';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { CreateCoachParams, useCreateCoachMutation } from 'features/coaches';
import { SelectImage } from 'features/imagesStore';
import { SelectTimePrice } from 'features/timesPrice';

type FormData = CreateCoachParams;

interface Props {
  handleCancel: () => void;
}

const initialValue = {
  metainfo: {
    rating: 5
  }
};

export const CreateCoachModal = ({ handleCancel }: Props) => {
  const [form] = Form.useForm<FormData>();

  const [create, { isSuccess, isError, isLoading, error }] = useCreateCoachMutation();

  useNotification({
    isSuccess,
    isError,
    error,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
  });

  const onFinish = (values: FormData) => {
    create(values);
  };

  return (
    <Modal
      title={t('coaches.title.create')}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
        initialValues={initialValue}
      >
        <InputStr type="name" formProps={{ rules: [{ required: true, message: t('coaches.validate.name') }] }} />
        <InputStr type="metainfo.description" />
        <SelectImage />
        <Form.Item name={['metainfo', 'rating']} label={t('form-items.input.metainfo.rating')}>
          <Rate allowHalf />
        </Form.Item>
        <SelectTimePrice formProps={{ form }} />
        <SubmiteButton submiteText={t('table.create')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};
